<template>
  <a-modal title="巡检管理" :visible="showTubeView" :width="800" destroyOnClose @ok="handleOk" @cancel="closeTubeView">
    <!-- <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map ref='lonlatMaps' @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal> -->
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-row class="form-row" type="flex" justify="center" :gutter="4">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="任务名称" prop="taskName">
            <a-input placeholder="请输入" v-model="addOrUpdateForm.taskName" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="巡检泵房" prop="pumpId">
            <a-select v-model="addOrUpdateForm.pumpId" placeholder="选择一个泵房绑定">
              <a-select-option v-for="(item, index) in userlis" :key="index" :value="item.key">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="巡检周期" prop="inspectionFrequency">
            <a-select placeholder="请选择任务类型" v-model="addOrUpdateForm.inspectionFrequency">
              <a-select-option key="日">日</a-select-option>
              <a-select-option key="周">周</a-select-option>
              <a-select-option key="月">月</a-select-option>
              <a-select-option key="年">年</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="负责人" prop="principal">
            <a-select
              show-search
              option-filter-prop="children"
              style="width: 200px"
              :filter-option="filterOption"
              v-model="addOrUpdateForm.principal"
              @change="handleChange"
              placeholder="请选择"
            >
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="开始时间" prop="nextInspecDate">
            <a-date-picker
              v-model="addOrUpdateForm.nextInspecDate"
              format="YYYY-MM-DD"
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              @change="onChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="预计处理时长" prop="planTime">
            <a-input placeholder="请输入" v-model="addOrUpdateForm.planTime" />
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :sm="24"> </a-col>
        <a-col :md="12" :sm="24"> </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="任务描述" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="description">
            <a-textarea placeholder="多行输入" v-model="addOrUpdateForm.description" :rows="4" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <addModal ref="addModal" @addPepople="addPepople"></addModal>
  </a-modal>
</template>
<script>
import dayjs from 'dayjs'
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
export default {
  components: {
    addModal,
    LonlatMap,
    dayjs,
  },

  props: {},
  data() {
    return {
      mapVisible: false,
      dayjs,
      queryOneUrl: '/pipe-network/inspection_managements',
      addOrUpdateUrl: '/pipe-network/inspection_managements',
      showTubeView: false,
      id: '',
      addOrUpdateForm: {
        place: '',
        inspectionItems: '',
        principal: '',
        assistPersons: [],
        inspectionFrequency: '',
        numberOfInspections: '',
        address: '',
        description: '',
        startTime: '',
        zone: '',
        nextInspectionDate: '',
        nextInspecDate: '',
        lastInspectionDate: '',
        pumpId: '',
        taskName: '',
        planTime: '',
      },
      zoneTreeData: [], // 分区数据选项
      userlis: [],
      eventTypeList: [],
      assistPersonsList: [],
      userlist: [],
      currentId: '',
      dates: '',
    }
  },
  computed: {
    rules() {
      return {
        principal: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        lastInspectionDate: [{ required: true, message: '请选择上次巡检日期', trigger: 'change' }],
        nextInspecDate: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        inspectionFrequency: [{ required: true, message: '请选择巡检周期', trigger: 'change' }],
        description: [{ required: true, message: '请选择输入任务描述', trigger: 'change' }],
        pumpId: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'change' }],
        planTime: [
          { required: true, message: '请输入预计处理时长', trigger: 'change' },
          { pattern: /^(?:[1-9]\d?|[1234]\d{2}|500)$/, message: '请输入正整数', trigger: 'change' },
        ],
      }
    },
  },
  created() {
    this.getZoneData()
    this.getUserList()
    this.getUserLi()
    // this.getCurrentTime()
  },
  methods: {
    disabledDate(current) {
      return current && current < dayjs().endOf('day')
    },
    disabledDateTime() {},
    getUserLi() {
      this.$http.get('/pipe-network/twice_water_pumps/list').then(({ data }) => {
        
        let list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.pumpName + ' (' + item.pumpNo + ')',
            key: item.id,
          })
        })
        this.userlis = list
      })
    },
    addAddress() {
      this.mapVisible = true
      if (this.addOrUpdateForm.place) {
        var pointData = this.addOrUpdateForm.place.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    handleMapOk(data) {
      this.addOrUpdateForm.address = data.address
      this.addOrUpdateForm.place = data.point
      console.log(this.addOrUpdateForm.address)
    },
    moment,
    handleChange(value) {
      console.log(value)
      this.addOrUpdateForm.principal = value
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getUserList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        
        this.userlist = data
      })
    },
    delSponsor(key) {
      let i = this.assistPersonsList.findIndex((item) => {
        return item.key == key
      })
      this.assistPersonsList.splice(i, 1)
      let j = this.addOrUpdateForm.assistPersons.indexOf(key)
      this.addOrUpdateForm.assistPersons.splice(j, 1)
    },
    addPepople(list) {
      this.assistPersonsList = list
      this.addOrUpdateForm.assistPersons = []
      list.map((item) => {
        this.addOrUpdateForm.assistPersons.push(item.key)
      })
    },
    showLineLayer(record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    addSponsor() {
      this.$refs.addModal.edit(this.addOrUpdateForm.assistPersons)
    },
    handleOk(e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, {
            id: this.currentId,
            sysType: '二次供水',
            ...this.addOrUpdateForm,
          })
            .then((res) => {
              if (res.code === 0) {
                this.closeTubeView()
                this.$emit('handleOk')
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    getZoneData() {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    onChange(value, dateString) {
      this.addOrUpdateForm.nextInspectionDate = dateString + ' 00:00:00'
    },
    onChanget(value, dateString) {
      console.log(dateString)
      this.addOrUpdateForm.lastInspectionDate = dateString + ' 00:00:00'
    },
    _updateForm(real, data) {
      let keys = Object.keys(real)
      let dataKeys = Object.keys(data)
      let newObject = {}
      keys.map((key) => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    edit(id) {
      this.showTubeView = true
      this.currentId = id
      this.addOrUpdateForm = {
        inspectionItems: '',
        principal: '',
        assistPersons: [],
        inspectionFrequency: '',
        numberOfInspections: '',
        address: '',
        startTime: '',
        description: '',
        zone: '',
        taskName: '',
        pumpId: '',
        lastInspectionDate: '',
        nextInspectionDate: '',
        planTime: '',
        inspectionItems: '',
        nextInspecDate: '',
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              console.log(this._updateForm(this.addOrUpdateForm, data))
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.getPeopleList()
            })
            .catch(() => {})
        }
      })
    },
    getPeopleList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        
        let list = []
        data.map((item) => {
          list.push({
            title: item.realName,
            key: item.id,
          })
        })

        if (this.addOrUpdateForm.assistPersons.length) {
          this.assistPersonsList = []
          this.addOrUpdateForm.assistPersons.map((item) => {
            this.assistPersonsList.push(
              list.find((listItem) => {
                return listItem.key == item
              })
            )
          })
          console.log(this.assistPersonsList, '1234')
        }
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.$refs.addOrUpdateForm.resetFields()
      console.log(this.addOrUpdateForm)
      this.assistPersonsList = []
      this.$emit('handleOk')
    },
  },
}
</script>

<style lang="less" scoped>
</style>
